<template>
  <div
    :id="chartsBarData.id"
    class="charts"
    :style="{width:'100%',height:chartsBarData.height}"
    ref="echarts"
  ></div>
</template>

<script>
//引入Echarts主模块
var echarts = require("echarts/lib/echarts");
//引入柱状图
require("echarts/lib/chart/bar");
//引入提示框、标题组件、工具栏、缩放组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/toolbox");
require("echarts/lib/component/dataZoom");
export default {
  props: {
    chartsBarData: {
      id: "",
      height: "",
      title: "",
      xData: [],
      yData: [],
      yData2: [],
      bottom:"",
      end:Number,
      path:"",//路由跳转路径
      idNum:[],//机构数据的id
      name:"",//下载图片名称
      legend:[],      
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.drawCharts();
  },
  methods: {
    drawCharts() {
      // 基于准备好的dom，初始化echarts实例
      // var myChart = echarts.init(document.getElementById(this.chartsBarData.id));
      var myChart = echarts.init(this.$refs.echarts);
      window.addEventListener("resize", () => {
        //echarts自适应宽度
        window.onresize = myChart.resize();
      });
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.chartsBarData.title,
          y: 0,
          x: 10,
          textStyle: {
            //文本样式
            color:"#606266",// 蓝色#295d99 橘色#b8573c
            fontWeight:400,
            fontSize: 14,
            lineHeight: 18
          }
        },
        grid: {
          //图表位置
          top: "7%",
          right: "3.5%",
          left: "90px",
          bottom: this.chartsBarData.bottom
        },
        /* dataZoom: [
          {
            type: "inside",
            start: 0,
            end: this.chartsBarData.end
          },
          {
            start: 0,
            end: 10,
            handleIcon:
              "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "80%",
            handleStyle: {
              color: "#fff",
              shadowBlur: 3,
              shadowColor: "rgba(0, 0, 0, 0.6)",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          }
        ], */
        toolbox: {
          //工具栏
          show: true,
          right: "1%",
          top: "0%",
          feature: {
            // dataView : {show: true, readOnly: false}, //数据视图工具
            // magicType: { show: true, type: ["line", "bar"] },//动态类型切换
            // restore: { show: true }, //配置项还原
            saveAsImage: {  //保存为图片
              show: true,
              name:this.chartsBarData.name
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow',
          },
        },
        legend:{
          top:"1%",
          textStyle: {
						color: "#000",
						fontSize: 14,
					},
          data:this.chartsBarData.legend
        },
        xAxis: {
          type: 'value',
          splitLine: {
            //调节网格线的样式、颜色
            show: true, //是否显示分割线，默认数值轴显示，类目轴不显示
            lineStyle: {
              color: "#bfbfbf"
            }
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#bfbfbf", //x轴的颜色
              width: "1" //坐标线的宽度
            }
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置
            textStyle: {
              color: "#4e452e" //坐标值得具体的颜色 蓝色#3d5470 橘色#4e452e
            },
            fontSize: 12, //x轴文字大小
            // rotate: "-30", //此处控制文字倾斜方向
            // formatter:function(value){ //文字过长省略显示
            //   return (value.length>10?(value.slice(0,10)+"..."):value);
            // }
            // formatter:'{value}篇'
          }
        },
        yAxis: {
          type: 'category',
          data: this.chartsBarData.xData,
          // splitLine: {
          //   //调节网格线的样式、颜色
          //   show: true, //是否显示分割线，默认数值轴显示，类目轴不显示
          //   lineStyle: {
          //     color: "#bfbfbf"
          //   }
          // },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#bfbfbf", //x轴的颜色
              width: "1" //坐标线的宽度
            }
          },
          axisLabel: {
            textStyle: {
              color: "#1f273f",
            }
          }
        },
        series: [
          {
            name: "整篇审查",
            type: "bar",
            barWidth : 18,//柱图宽度
            itemStyle: {
              normal: {
                show: true,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "#4EA2EA" 
                  },
                  {
                    offset: 1,
                    color: "#6AD0F2"
                  }
                ]),
                barBorderRadius: 50,
                borderWidth: 2, // 拐点描边线宽！！！！ 柱状图折线图切换
                // label: {
                //   //此处为在图标上显示数值！！！！
                //   show: true, //开启显示
                //   position: "right", //在上方显示
                //   textStyle: {
                //     //数值样式
                //     color: "#4e452e", //蓝色#375166 橘色#4e452e
                //     fontSize: 12
                //   }
                // }
              }
            },
            // label: {
            //   normal: {
            //     color: '#b3ccf8',
            //     show: true,
            //     position:['5px', '-14px'],//[0, '-24px'] y轴文字显示位置
            //     textStyle: {
            //       fontSize: 13
            //     },
            //     formatter: function (a, b) {
            //       return a.name
            //     }
            //   }
            // },
            data: this.chartsBarData.yData
          },
          {
            name: "条目审查",
            type: "bar",
            barWidth : 18,//柱图宽度
            itemStyle: {
              normal: {
                show: true,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "#8879F6" 
                  },
                  {
                    offset: 1,
                    color: "#B4BFFD"
                  }
                ]),
                barBorderRadius: 50,
                borderWidth: 2, // 拐点描边线宽！！！！ 柱状图折线图切换
                // label: {
                //   //此处为在图标上显示数值！！！！
                //   show: true, //开启显示
                //   position: "right", //在上方显示
                //   textStyle: {
                //     //数值样式
                //     color: "#4e452e", //蓝色#375166 橘色#4e452e
                //     fontSize: 12
                //   }
                // }
              }
            },
            // label: {
            //   normal: {
            //     color: '#b3ccf8',
            //     show: true,
            //     position:['5px', '-14px'],//[0, '-24px'] y轴文字显示位置
            //     textStyle: {
            //       fontSize: 13
            //     },
            //     formatter: function (a, b) {
            //       return a.name
            //     }
            //   }
            // },
            data: this.chartsBarData.yData2
          }
        ]
      });
      //点击图表跳转
      // myChart.off('click');
      // myChart.on('click',(params)=>{
      //   console.log(params)
      //   //dataIndex 数据索引值
      //   console.log(this.chartsBarData.path)
      //   var url=this.$router.resolve({
      //     path: this.chartsBarData.path,
      //     // query: { uuid: _this.uuid[params.dataIndex] }
      //     query: { id:this.chartsBarData.idNum[params.dataIndex]}
      //   });
      //   window.open(url.href,'_blank');
      // });
    }
  }
};
</script>
<style scoped>
</style>
